import React, {Component} from 'react'
import {connect} from 'react-redux'

import DomainListItem from '../../components/DomainListItem'
import {TransitionGroup} from 'react-transition-group'

import MediaQuery from 'react-responsive'
import {removeDomainFromCart} from "../../actions/Cart";
import {getDomainInCartObject} from "../../selectors/CartUtil";
import CollapsingTransitionGroup from "../../components/CollapsingTransitionGroup";

class AddedToCartListing extends Component {


    static propTypes = {}

    isDomainGettingRemovedFromCart = (itemId) => {
        return this.props.domainsGettingRemovedFromCart.includes(itemId)
    }

    render() {

        const listItems = this.props.domainsAddedToCart.map((domainObject) =>
            <DomainListItem
                key={"remove_" + domainObject.domain}
                domainName={domainObject.domainName}
                domainEnding={domainObject.domainEnding}
                domainPriceMonthly={"" + domainObject.priceMonthly}
                domainPriceSetup={"" + domainObject.setupFee}
                uiState="added"
                isGettingRemovedFromCart={this.isDomainGettingRemovedFromCart(domainObject.itemId)}
                onClick={() => {
                    this.props.removeItemFromCart(domainObject.itemId)
                }}
            />
        )

        const tableHeaders = []


        if (this.props.domainsAddedToCart.length > 0) {
            tableHeaders.push(<div className={"domain-listing__header__price"} key="added_domains_einmalig">einmalig</div>)
            tableHeaders.push(<MediaQuery key="added_domains_monatlich" maxWidth={759}>{(isMatching) => {
                return isMatching ? <div className={"domain-listing__header__price"}>mtl.</div> : <div className={"domain-listing__header__price"}>monatlich</div>
            }}</MediaQuery>)
        }

        return this.props.domainsAddedToCart.length !== 0 ? <div className="domain-step__domains-added">
                <CollapsingTransitionGroup>
                    {(this.props.domainsAddedToCart.length !== 0) ? <div className="domain-listing__header">
                        <div>
                            <MediaQuery maxWidth={759}>{(isMatching) => {
                                return isMatching ? <h2>Hinzugefügt</h2> : <h2>Hinzugefügte Domains</h2>
                            }}</MediaQuery>
                        </div>
                        {tableHeaders}
                    </div> : null}
                </CollapsingTransitionGroup>
                <TransitionGroup
                    component="div"
                    className="domain-listing">
                    {listItems}
                </TransitionGroup>
            </div> : null;
    }

}


const mapStateToProps = (state) => {

    return {
        domainsAddedToCart: getDomainInCartObject(state),
        domainsGettingRemovedFromCart: state.domainCheck.domainsGettingRemovedFromCart
    }

}


const mapDispatchToProps = (dispatch) => {

    return {
        removeItemFromCart: (itemId) => {
            dispatch(removeDomainFromCart(itemId))
        }
    }

}
export default connect(mapStateToProps, mapDispatchToProps)(AddedToCartListing)



/** WEBPACK FOOTER **
 ** ./src/containers/domainstep/AddedToCartListing.js
 **/